import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { ExpiringCreditTransactionsQueryVariables } from '@/gql/graphql';

export const fetchExpiringCreditTransactions = async ({ phoneNumber, pagination }: ExpiringCreditTransactionsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query ExpiringCreditTransactions($phoneNumber: String, $pagination: PaginationInputType) {
        expiringCreditTransactions(phoneNumber: $phoneNumber, pagination: $pagination) {
          count
          rows {
            id
            date
            category
            description
            notes
            currency
            amount
            associatedObjectType
            associatedObjectId
            createdAt
            updatedAt
            status
            errorCode
            ipAddress
            ipCountry
            device
            operatingSystem
            browser
            user {
              firstName
              lastName
              role
            }
            distributions {
              transactionId
              sortOrder
              class
              account
              amount
              associatedObjectType
              associatedObjectId
              stripeCustomerId
              stripeChargeId
              stripeRefundId
              createdAt
              status
            }
          }
        }
      }
    `),
    variables: {
      phoneNumber,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.expiringCreditTransactions;
};
